import { useQuery } from '@tanstack/react-query';

import { useProblemReportsList } from './useProblemReportsList';

import { sdk } from '@/services';

const ProblemReportService = sdk.getService('ProblemReportService');

export const useDownloadProblemReports = () => {
  const { filter, search, pagination, sortBy, sortOrder } = useProblemReportsList();

  const filtersWithSort = {
    ...filter,
    ...(sortBy && { sortBy }),
    ...(sortOrder && { sortOrder })
  };

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ['problem-reports', 'download', search, filtersWithSort, pagination?.totalDocs],
    queryFn: () => ProblemReportService.downloadProblemReports(search, filtersWithSort),
    enabled: false
  });

  const downloadProblemReports = async () => {
    const result = await refetch();
    return result.data;
  };

  return { downloadProblemReports, data, error, isLoading };
};
